import { Injectable } from '@angular/core';
import { IMessage } from '@bciti/types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export abstract class MessageService {
    abstract getMessages(organisation: string, actions: string[], status: string[], userId: string, dateStart: string, dateEnd: string): Observable<IMessage[]>;
    abstract getDiagnostic(): Observable<any>;
}
